import React from 'react';
import Component from '@vfuk/core-select-input-with-label';
const SelectInputWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SelectInputWithLabel;
